$bog_ui_app_table $mol_page
	title \Data Table
	body /
		<= Description $mol_view
			sub /
				<= description \Data table with sorting, row selection, and zebra striping. Click column headers to sort. Use checkboxes to select rows.
		<= Selected_info $mol_view
			sub /
				<= selected_text \No rows selected
		<= Table $bog_ui_table
			columns <= columns /
			data <= data /
			selectable true
			selected? <=> selected? /
			sort_column? <=> sort_column? \
			sort_dir? <=> sort_dir? \asc
